import { createFileRoute } from '@tanstack/react-router'

import { CredentialGroupsPage } from '#/modules/loadboards/credential-groups-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/check-rate')({
  component: function CheckRateRoute() {
    // TheCargo's own Super Dispatch credentials — the platform lends these out.
    return <CredentialGroupsPage isPlatform title="Check Rate" />
  },
  validateSearch: validateListSearch,
})
